module.exports = __webpack_public_path__ + "assets/img/translation-app-bg.96bc9046.png";